import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import "./EligibilityLeads.css";

const EligibilityLeads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) return;

    axios
      .get(`https://be.corebankers.in/eligibility-leads?userId=${userId}`)
      .then((res) => {
        setLeads(res.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch eligibility leads:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <CircularProgress sx={{ m: 4 }} />;

  return (
    <Box p={3}>
      <Typography
        variant="h6"
        fontWeight="bold"
        align="center"
        sx={{ mb: 3, color: "#333" }}
        className="eli-heading"
      >
        📝 Eligibility Leads
      </Typography>

      <Paper elevation={3} className="eli-container">
        <TableContainer>
          <Table size="small">
            <TableHead className="eli-header">
              <TableRow>
                <TableCell align="center" className="eli-header-cell">Lead ID</TableCell>
                <TableCell align="center" className="eli-header-cell">Name</TableCell>
                <TableCell align="center" className="eli-header-cell">Mobile Number</TableCell>
                <TableCell align="center" className="eli-header-cell">Employment Type</TableCell>
                <TableCell align="center" className="eli-header-cell">Loan Type</TableCell>
                <TableCell align="center" className="eli-header-cell">Req Loan Amt</TableCell>
                <TableCell align="center" className="eli-header-cell">Monthly Income</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leads.map((lead, idx) => (
                <TableRow
                  key={idx}
                  className={idx % 2 === 0 ? "row-even" : "row-odd"}
                  style={{ cursor: "pointer" }}
                >
                  <TableCell align="center">{lead.id}</TableCell>
                  <TableCell align="left">{lead.name || ""}</TableCell>
                  <TableCell align="center">{lead.mobile_number || ""}</TableCell>
                  <TableCell align="center">{lead.employment || ""}</TableCell>
                  <TableCell align="center">{lead.loan_type || ""}</TableCell>
                  <TableCell align="center">{lead.req_loan_amt || ""}</TableCell>
                  <TableCell align="center">{lead.monthly_income || ""}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default EligibilityLeads;